import { render, staticRenderFns } from "./VehicleBookingContent.vue?vue&type=template&id=4074134e"
import script from "./VehicleBookingContent.vue?vue&type=script&lang=ts"
export * from "./VehicleBookingContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports